import { FeedbackEntityTypes, IFeedbackEntity } from "@common/redux/types/feedbacks";
import { EntityType } from "@common/redux/types/common";

const hashMapEntity = new Map<EntityType, FeedbackEntityTypes>([
  ['events', 'event'],
  ['places', 'place'],
  ['hotels', 'hotel'],
  ['restaurants', 'restaurant'],
  ['touristroutes', 'touristRoute'],
  ['overviews', 'article'],
  ['streams', 'stream'],
  ['news', 'article'],
  ['excursions', 'excursion'],
  ['tours', 'tour'],
]);

export const prepareEntity = (entityType: EntityType, entityId: number): IFeedbackEntity => {
  return {
    type: hashMapEntity.get(entityType),
    [`${hashMapEntity.get(entityType)}Id`]: entityId
  }
};
